import React, { useEffect } from "react"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"

import { useDivRef } from "../../hooks/useDivRef"

import styles from "./index.module.less"

const ItemFrame = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{
        img: string
        status?: "gray" | "normal" | "bright"
        onClick?: () => void
    }>
>(({ className, style, img, status = "normal", onClick }, ref) => {
    return (
        <div
            ref={ref}
            onClick={onClick}
            className={classNames(styles.itemFrame, styles[status], className)}
            style={style}
        >
            <div
                className={classNames(styles.itemImage, !img && styles.noImage)}
                style={{ backgroundImage: img ? `url(${img})` : undefined }}
            ></div>
        </div>
    )
})
ItemFrame.displayName = "ItemFrame"

export default ItemFrame
